var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile = function SvgFile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2333_1415)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 2.50002C3.3335 2.03978 3.70659 1.66669 4.16683 1.66669H11.6668C11.8878 1.66669 12.0998 1.75448 12.2561 1.91076L16.4228 6.07743C16.579 6.23371 16.6668 6.44567 16.6668 6.66669V15.8334C16.6668 17.2141 15.5475 18.3334 14.1668 18.3334H5.8335C4.45278 18.3334 3.3335 17.2141 3.3335 15.8334V2.50002ZM5.00016 3.33335V15.8334C5.00016 16.2936 5.37326 16.6667 5.8335 16.6667H14.1668C14.6271 16.6667 15.0002 16.2936 15.0002 15.8334V7.01187L11.3217 3.33335H5.00016Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.5V2.5H11.6667V6.66667H15.8333V8.33333H10.8333C10.3731 8.33333 10 7.96024 10 7.5Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 10.8333C6.6665 10.3731 7.0396 10 7.49984 10H12.4998C12.9601 10 13.3332 10.3731 13.3332 10.8333C13.3332 11.2936 12.9601 11.6667 12.4998 11.6667H7.49984C7.0396 11.6667 6.6665 11.2936 6.6665 10.8333Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 14.1666C6.6665 13.7064 7.0396 13.3333 7.49984 13.3333H12.4998C12.9601 13.3333 13.3332 13.7064 13.3332 14.1666C13.3332 14.6269 12.9601 15 12.4998 15H7.49984C7.0396 15 6.6665 14.6269 6.6665 14.1666Z",
    fill: "#2196F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2333_1415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "file.b14ef8b49ad511dbda7b7d9365dee908.svg";